export default __webpack_public_path__ + "static/media/about-sec-img.e03ff14d.png";